import React, { useEffect, useState, useRef, useMemo } from 'react';
import SecurityService from '../security/security.service';
import '../PI/PI.scss';
import HardDelete from '../hard-delete/hard-delete';
import TemplateCode from '../template-code/template-code';
import {
  GridComponent,
  Inject,
  Toolbar,
  Edit,
  Page,
  Sort,
  PdfExport,
  ExcelExport,
  Resize,
  Filter,
  Group,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  Freeze,
  ColumnChooser,
  Reorder,
  CommandColumn,
} from '@syncfusion/ej2-react-grids';
import PISalesAgentAdd from './PI-sales-agent-add';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import moment from 'moment';
import PIMessageButtonList from '../messages-button-list/messages-button-list';
import PISalesAgentService from '../../services/PI-sales-agent.service';
import EmailEditorPopup from '../PI/email-editor-popup';
import imgSrc from '../upload-supplier/spinner.gif';
import '@fortawesome/fontawesome-free/css/all.css';
import { useDispatch, useSelector } from 'react-redux';
import { gridColumnsList } from '../../store/slices/list-tempate';
import UploadPdfFile from '../upload-pdf-files/upload-pdf-files-list';
import { decryptData } from '../decryption/decryption';

let ProformaInvoiceGrid;
let setPIID = '';

const formatOptions = { type: 'date', format: 'dd/MM/yy' };
const customPageSizes = [100, 200, 500, 1000, 'All'];
const loadingIndicator = { indicatorType: 'Shimmer' };

const commands = [
  { buttonOption: { id: 'email', content: 'E', cssClass: 'e-flat', isPrimary: true } },
  { buttonOption: { id: 'message', content: 'M', cssClass: 'e-flat', isPrimary: true } },
  { buttonOption: { id: 'uploadPDF', content: 'A', cssClass: 'e-flat', isPrimary: true } },
];

// Same field set the Sales Agent role sees today (no Base Price Agent/Company —
// those are Supervisor-only, and no CRM-only columns).
const ColumnProps = [
  { field: 'Commands', headerText: 'Commands', width: '180', textAlign: 'center', headerTextAlign: 'center', other: [{ commands }] },
  { field: 'PIID', headerText: 'ID', width: '100', textAlign: 'Left', headerTextAlign: 'center', other: [{ visible: false }] },
  { field: 'SerialNo', headerText: 'Serial No', width: '70', textAlign: 'Right', headerTextAlign: 'center', other: [] },
  { field: 'PINo', headerText: 'PI No', width: '110', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'PIReferenceNo', headerText: 'PI Reference No', width: '120', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'SupplierName', headerText: 'Supplier', width: '140', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'CustomerName', headerText: 'Customer', width: '150', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'CustomerEmail', headerText: 'Customer Email', width: '150', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'SalesAgentName', headerText: 'Sales Agent', width: '130', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'ConsigneeName', headerText: 'Consignee', width: '155', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'ConfirmConsigneeName', headerText: 'Confirm Consignee', width: '155', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'CommissionAmountPerUnit', headerText: 'Commission Amt Per Unit', width: '155', textAlign: 'Left', headerTextAlign: 'center', other: [{ visible: false, format: 'n0' }] },
  { field: 'ApproveCommissionAmountPerUnit', headerText: 'Approve Commission Amt Per Unit', width: '155', textAlign: 'Left', headerTextAlign: 'center', other: [{ visible: false }] },
  { field: 'AbsoluteCommissionAmount', headerText: 'Commission Absolute Comm Amt', width: '155', textAlign: 'Left', headerTextAlign: 'center', other: [{ visible: false, format: 'n0' }] },
  { field: 'ApproveAbsoluteCommissionAmount', headerText: 'Approve Commission Absolute Comm Amt', width: '155', textAlign: 'Left', headerTextAlign: 'center', other: [{ visible: false }] },
  { field: 'CountryName', headerText: 'Country', width: '140', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'CityName', headerText: 'City', width: '120', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'PortName', headerText: 'Port', width: '120', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'ShipmentType', headerText: 'Shipment Type', width: '140', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'BookAmount', headerText: 'Booking Amount', width: '135', textAlign: 'Right', headerTextAlign: 'center', other: [{ format: 'n0' }] },
  { field: 'CurrencyName', headerText: 'Currency', width: '150', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'PrimaryCommissionPercentOnAdjustment', headerText: 'Primary Comm % On Adjustment', width: '155', textAlign: 'Left', headerTextAlign: 'center', other: [{ visible: false }] },
  { field: 'SecondaryCommissionPercentOnAdjustment', headerText: 'Secondary Comm % On Adjustment', width: '155', textAlign: 'Left', headerTextAlign: 'center', other: [{ visible: false }] },
  { field: 'ApproveSecondaryCommissionPercentOnAdjustment', headerText: 'Approve Secondary Comm % On Adjustment', width: '155', textAlign: 'Left', headerTextAlign: 'center', other: [{ visible: false }] },
  { field: 'AdjustmentAmount', headerText: 'Adjustment Amount', width: '165', textAlign: 'Right', headerTextAlign: 'center', other: [{ format: 'n0' }] },
  { field: 'PurchaseSource', headerText: 'Purchase Source', width: '150', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'TradeBoardLetterStatus', headerText: 'Trade Board Letter', width: '145', textAlign: 'center', headerTextAlign: 'center', other: [{ visible: false }] },
  { field: 'Remarks', headerText: 'Remarks', width: '140', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'CreationDate', headerText: 'Creation Date', width: '140', textAlign: 'Right', headerTextAlign: 'center', other: [{ format: formatOptions, type: 'date' }] },
  { field: 'UserName', headerText: 'User Name', width: '140', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'VesselName', headerText: 'Vessel Name', width: '140', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'VoyageNo', headerText: 'Voyage No', width: '130', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'ETD', headerText: 'ETD', width: '120', textAlign: 'Right', headerTextAlign: 'center', other: [{ format: formatOptions, type: 'date' }] },
  { field: 'ETA', headerText: 'ETA', width: '120', textAlign: 'Right', headerTextAlign: 'center', other: [{ format: formatOptions, type: 'date' }] },
  { field: 'ReceiptAmount', headerText: 'ALLOCATION AMOUNT', width: '130', textAlign: 'Right', headerTextAlign: 'center', other: [{ format: 'n0' }] },
  { field: 'ShortAmount', headerText: 'Short Amount', width: '130', textAlign: 'Right', headerTextAlign: 'center', other: [{ format: 'n0' }] },
  { field: 'UnApprovedCRMAmount', headerText: 'UnApproved CRM Amount', width: '130', textAlign: 'Right', headerTextAlign: 'center', other: [{ format: 'n0' }] },
  { field: 'SalesAgentStatus', headerText: 'Sales Agent Status', width: '145', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'SalesAgentStatusDate', headerText: 'Sales Agent Status Date', width: '140', textAlign: 'Right', headerTextAlign: 'center', other: [{ format: formatOptions, type: 'date' }] },
  {
    field: 'PaymentVerificationStatus', headerText: 'Payment Verification Status', width: '175', textAlign: 'center', headerTextAlign: 'center',
    other: [{
      template: (rowProps) => (
        <div className={rowProps.PaymentVerificationStatus === 'PENDING VERIFICATION' ? 'pendingPayment' : ''}>
          {rowProps.PaymentVerificationStatus}
        </div>
      ),
    }],
  },
  { field: 'PaymentVerificationStatusDate', headerText: 'Payment Verification Status Date', width: '175', textAlign: 'Right', headerTextAlign: 'center', other: [{ format: formatOptions, type: 'date' }] },
  { field: 'CRMName', headerText: 'CRM Name', width: '145', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'CRMStatus', headerText: 'CRM Status', width: '140', textAlign: 'center', headerTextAlign: 'center', other: [] },
  { field: 'CRMStatusDate', headerText: 'CRM Status Date', width: '145', textAlign: 'Right', headerTextAlign: 'center', other: [{ format: formatOptions, type: 'date' }] },
];

export default function PISalesAgentList() {
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.listTemplate);

  const [dataSourceState, setDataSourceState] = useState([]);
  const [deletingProps, setDeletingProps] = useState();
  const [showDialogs, setShowDialogs] = useState(false);
  const [printedByUserName, setPrintedByUserName] = useState();
  const [printedByEmail, setPrintedByEmail] = useState();
  const [showDialogEmail, setShowDialogEmail] = useState(false);
  const [showDialogMessage, setShowDialogMessage] = useState(false);
  const [showDialoguploadPDF, setShowDialoguploadPDF] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [piisLoading, setPiisLoading] = useState(false);
  const [callButton, setCallButton] = useState(false);
  const [onLoad, setOnLoad] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [ToggledValue, setToggledValue] = useState('Hide Template');
  const [showDialogOfProduct, setShowDialogOfProduct] = useState(false);

  const deleteDialog = useRef();
  const visibleSortPassFields = useRef(['SerialNo']);
  const visibleSortPass = useRef(['Descending']);
  const ctrlPressed = useRef(false);
  const isSaveModeRef = useRef(false);
  let groupingArray = [];

  const userId = SecurityService.getLoggedInUserId();
  const InputListSecurity = 'PISalesAgentList';
  const exportFileName = 'PI_information';

  useEffect(() => {
    const filteredArr = ColumnProps.filter((obj) => Object.keys(obj).length !== 0);
    dispatch(gridColumnsList(filteredArr));
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setToggledValue(isToggled === true ? 'Hide Template' : 'Show Template');
    }, 100);
  }, [isToggled]);

  useEffect(() => {
    (async () => {
      await getListService();
      setTimeout(() => setOnLoad(true), 2500);
      SecurityService.getUserAccessList(userId).then((res) => {
        const decrypted = decryptData(res.data);
        setPrintedByUserName(decrypted[0].UserName);
      });
      SecurityService.getEmployeeEmailByUserID(userId).then((res) => {
        const decrypted = decryptData(res.data);
        setPrintedByEmail(decrypted[0].EmployeeEmail);
      });
    })();
  }, []);

  const getListService = async () => {
    setPiisLoading(true);
    // Filtered server-side by SalesAgentID (resolved from the logged-in UserID on
    // the backend) instead of fetching every PI for every agent in the company
    // and discarding almost all of it client-side after decrypting the whole
    // payload — that was the entire cause of the slow initial load.
    // PaymentVerificationStatus: 2 is spProformaInvoice's own "show every status"
    // sentinel (its WHERE clause explicitly treats 2 as covering verified,
    // invalid, and pending all together). Leaving this param unset arrives at
    // the SP as NULL, which its WHERE clause instead matches to "pending
    // verification only" -- so without this, the agent only ever saw their
    // unverified PIs instead of all of them.
    return PISalesAgentService.PIForlist({ UserID: SecurityService.getLoggedInUserId(), PaymentVerificationStatus: 2 })
      .then((response) => {
        const decryptedData = decryptData(response.data);
        setPiisLoading(false);
        setTimeout(() => setCallButton(true), 400);

        const data = decryptedData.map((v) => {
          v.SalesAgentStatusDate = v.SalesAgentStatusDate == null ? null : new Date(v.SalesAgentStatusDate.split('T', 1)[0]);
          v.ETA = v.ETA == null ? null : new Date(v.ETA.split('T', 1)[0]);
          v.ETD = v.ETD == null ? null : new Date(v.ETD.split('T', 1)[0]);
          v.CreationDate = v.CreationDate == null ? null : new Date(v.CreationDate.split('T', 1)[0]);
          v.CRMStatusDate = v.CRMStatusDate == null ? null : new Date(v.CRMStatusDate.split('T', 1)[0]);
          v.PaymentVerificationStatusDate = v.PaymentVerificationStatusDate == null ? null : new Date(v.PaymentVerificationStatusDate.split('T', 1)[0]);
          v.ConfirmConsigneeName = v.ConfirmConsigneeName ? 'Yes' : 'No';
          return v;
        });
        setDataSourceState(data);
      })
      .catch((e) => {
        setPiisLoading(false);
        console.log(e);
      });
  };

  const updateProformaInvoice = (id, value) => {
    PISalesAgentService.updatingSp(id, value).catch((e) => console.log(e));
  };

  // After the Add/Edit dialog closes, PI-sales-agent-add.js reports whether the
  // summed payment rows match BookAmount (within tolerance) via popup(resultOfSums).
  const isShowPopup = (resultOfSums) => {
    setTimeout(() => {
      if (!isSaveModeRef.current) return;
      if (resultOfSums === true) {
        setTimeout(() => setShowDialogOfProduct(true), 200);
      } else if (setPIID !== '') {
        updateProformaInvoice(setPIID, 'undefined');
        setTimeout(() => {
          setPiisLoading(true);
          getListService();
        }, 200);
      }
      isSaveModeRef.current = false;
    }, 500);
  };

  const deleteButtons = [
    {
      buttonModel: { content: 'Release', cssClass: 'e-flat', isPrimary: true },
      click: () => {
        deleteDialog.current.hide();
        if (setPIID !== '') {
          updateProformaInvoice(setPIID, 'Release');
          setTimeout(() => {
            setPiisLoading(true);
            getListService();
          }, 200);
        }
      },
    },
    {
      buttonModel: { content: 'Surrender BL', cssClass: 'e-flat' },
      click: () => {
        deleteDialog.current.hide();
        if (setPIID !== '') {
          updateProformaInvoice(setPIID, 'Surrender BL');
          setTimeout(() => {
            setPiisLoading(true);
            getListService();
          }, 200);
        }
      },
    },
  ];

  const deleteDialogClose = () => setShowDialogOfProduct(false);

  const getpiid = (id) => {
    setPIID = id;
  };

  const toolbarClick = (args) => {
    const orientationCheckbox = document.getElementsByClassName('orientation')[0];
    const selectedOrientation = orientationCheckbox?.checked === true ? 'Portrait' : 'Landscape';

    if (ProformaInvoiceGrid && args.item.properties.id === 'ProformaInvoiceGrid_PDFExport') {
      ProformaInvoiceGrid.pdfExport({
        pageOrientation: selectedOrientation,
        fileName: `${moment().format('YYYYMMDD')}_${exportFileName}.pdf`,
      });
    }
    if (ProformaInvoiceGrid && args.item.properties.id === 'ProformaInvoiceGrid_excelexport') {
      ProformaInvoiceGrid.excelExport({
        pageOrientation: selectedOrientation,
        fileName: `${moment().format('YYYYMMDD')}_${exportFileName}.xlsx`,
      });
    }
    if (ProformaInvoiceGrid && args.item.properties.id === 'Delete') {
      if (ProformaInvoiceGrid.selectedRowIndex === -1) {
        setDeletingProps({ TableName: 'ProformaInvoice', ColumnName: 'PIID', RowID: undefined, SelectedRow: false });
      } else {
        setDeletingProps({
          TableName: ['ProformaInvoice', 'ProformaInvoice_PaymentDetail'],
          ColumnName: ['PIID'],
          RowID: ProformaInvoiceGrid.getSelectedRecords()[0]?.PIID,
          SelectedRow: true,
          SelectedRowData: ProformaInvoiceGrid.getSelectedRecords()[0],
        });
      }
      setShowDialogs(true);
    }
  };

  // isSaveModeRef used to be set by the outer grid's own native actionComplete
  // ('requestType' === 'save'), which fired when Syncfusion's auto-generated
  // dialog Save button was clicked. That button is now permanently hidden (it
  // had no connection to the real save logic and only confused users), so its
  // save event never fires anymore -- meaning isSaveModeRef.current stayed
  // false forever, isShowPopup always bailed out early, and the
  // spUpdateSalesAgentAndCRMStatus recompute (which sets SalesAgentStatus /
  // SalesAgentStatusDate) never ran. onSaved already only fires on a genuine
  // successful save from the real SAVE button, so set the flag there instead.
  const onPISaved = () => {
    isSaveModeRef.current = true;
    getListService();
  };

  const dialogTemplate = (rowProps) => (
    <PISalesAgentAdd
      dataList={dataSourceState}
      userName={printedByUserName}
      PIIDGet={getpiid}
      popup={isShowPopup}
      onSaved={onPISaved}
      {...rowProps}
      type="SalesAgent"
    />
  );

  const headerTemplate = (e) => (e.isAdd ? <p>Add New PI</p> : <p>Details Of PI</p>);

  const editSettings = {
    allowEditing: SecurityService.canUserAccess('PISalesAgentEdit') || true,
    allowAdding: SecurityService.canUserAccess('PISalesAgentAdd'),
    allowDeleting: SecurityService.canUserAccess('PISalesAgentDelete'),
    mode: 'Dialog',
    showDeleteConfirmDialog: true,
    template: dialogTemplate,
    headerTemplate,
    footerTemplate: '',
  };

  const filterOptions = { type: 'Excel' };
  const groupOptions = { showDropArea: true, columns: [] };

  const actionComplete = (args) => {
    ProformaInvoiceGrid?.autoFitColumns();
    if (args.requestType === 'grouping') groupingArray.push(args.columnName);
    if (args.requestType === 'ungrouping') groupingArray.splice(groupingArray.indexOf(args.columnName), 1);

    if (args.requestType === 'sorting') {
      if (ctrlPressed.current) {
        if (!(args.columnName === visibleSortPassFields.current[0] && visibleSortPassFields.current.length === 1)) {
          if (visibleSortPassFields.current.includes(args.columnName)) {
            visibleSortPass.current[visibleSortPassFields.current.indexOf(args.columnName)] = args.direction;
          } else {
            visibleSortPassFields.current.push(args.columnName);
            visibleSortPass.current.push(args.direction);
          }
        }
      } else {
        visibleSortPassFields.current = [args.columnName];
        visibleSortPass.current = [args.direction];
      }
    }

    if (args?.requestType === 'columnstate') {
      ProformaInvoiceGrid?.autoFitColumns();
    }

    if (args.form) {
      if (args.requestType === 'save') {
        isSaveModeRef.current = true;
        setPiisLoading(true);
        setTimeout(() => getListService(), 2000);
      }
      if (args.requestType === 'save' && args.action === 'edit') {
        const data = {
          UserID: userId,
          ...args.data,
          PIDate: moment(args.data.PIDate).format('YYYY-MM-DD'),
          ETD: args.data.ETD != undefined ? moment(args.data.ETD).format('YYYY-MM-DD') : null,
          ETA: args.data.ETA != undefined ? moment(args.data.ETA).format('YYYY-MM-DD') : null,
          ApproveAbsoluteCommissionAmount: args.data.ApproveAbsoluteCommissionAmount === false ? '0' : '1',
          ConfirmConsigneeName: args.data.ConfirmConsigneeNames === 'true',
          ApproveCommissionAmountPerUnit: args.data.ApproveCommissionAmountPerUnit === false ? '0' : '1',
        };
        PISalesAgentService.PIEdit(data).catch((e) => console.log(e));
      }
    }
  };

  const actionBegin = () => {};

  const commandClick = (args) => {
    if (args.commandColumn.buttonOption.id === 'email') {
      setSelectedRow(args.rowData);
      setShowDialogEmail(true);
    } else if (args.commandColumn.buttonOption.id === 'message') {
      setSelectedRow(args.rowData);
      setShowDialogMessage(true);
    } else if (args.commandColumn.buttonOption.id === 'uploadPDF') {
      setSelectedRow(args.rowData);
      setShowDialoguploadPDF(true);
    }
  };

  const uploadPDFHeader = () => <div className="dialog-header">Upload PDF Files.</div>;
  const emailHeader = () => <div className="dialog-header">Email</div>;
  const onCloseUploadPDF = () => setShowDialoguploadPDF(false);
  const footerTemplate = () => (
    showDialoguploadPDF ? (
      <div>
        <button id="btnSave" className="e-control e-btn e-primary" data-ripple="true" onClick={onCloseUploadPDF}>Close</button>
      </div>
    ) : <></>
  );

  const contentuploadPDF = () => <div><UploadPdfFile {...selectedRow} /></div>;
  const contentEmailTemplate = () => (
    <div><EmailEditorPopup {...selectedRow} loggedInUser={printedByEmail} isPreview={false} /></div>
  );
  const contentMessageTemplate = () => (
    SecurityService.canUserAccess('PIMessageList')
      ? <div className="dashboard-pi-view"><PIMessageButtonList isDialog={false} {...selectedRow} /></div>
      : <div className="returnlist" />
  );
  const emailDialogClose = () => setShowDialogEmail(false);
  const messageDialogClose = () => setShowDialogMessage(false);

  const databound = (allowDataBound = false) => {
    setTimeout(() => {
      if (ProformaInvoiceGrid && allowDataBound === true) {
        ProformaInvoiceGrid.autoFitColumns();
      }
    }, 200);
  };

  const getColumnsDetail = () => ProformaInvoiceGrid.getColumns();

  const ListGridComponent = () => {
    const columns = useMemo(() => {
      if (reduxData.gridColumnsListWithDetails.length > 0) {
        return reduxData.gridColumnsListWithDetails.map((field, index) => (
          field.field === 'Commands' ? (
            <ColumnDirective key={index} headerText={field.headerText} width={field.width} headerTextAlign={field.headerTextAlign} textAlign={field.textAlign} {...field.other[0]} />
          ) : (
            <ColumnDirective key={field.field} headerText={field.headerText} id={field.field} field={field.field} width={field.width} headerTextAlign={field.headerTextAlign} textAlign={field.textAlign} {...field.other[0]} />
          )
        ));
      }
      return <ColumnDirective visible={false} />;
    }, [reduxData.gridColumnsListWithDetails.length > 0]);

    return (
      <GridComponent
        ref={(grid) => (ProformaInvoiceGrid = grid)}
        id="ProformaInvoiceGrid"
        dataSource={dataSourceState}
        editSettings={editSettings}
        toolbar={[
          'Add', 'Edit',
          { text: 'Delete', tooltipText: 'Delete', id: 'Delete', disabled: !SecurityService.canUserAccess('PISalesAgentDelete') },
          'Update', 'Cancel', 'PDFExport', 'ExcelExport', 'Search', 'ColumnChooser',
        ]}
        pageSettings={{ pageSizes: customPageSizes, pageCount: 4, pageSize: 100 }}
        filterSettings={filterOptions}
        groupSettings={groupOptions}
        actionComplete={actionComplete}
        allowTextWrap="true"
        allowPaging={true}
        allowSorting={true}
        allowPdfExport={true}
        allowExcelExport={true}
        toolbarClick={toolbarClick}
        allowFiltering={true}
        allowGrouping={true}
        showColumnChooser={true}
        allowFreezePane={true}
        allowReordering={true}
        allowResizing={true}
        allowFreeze={true}
        loadingIndicator={loadingIndicator}
        enableHover={false}
        actionBegin={actionBegin}
        sortSettings={reduxData.gridSortingOptionsDetails}
        commandClick={commandClick}
        dataBound={databound}
        rowDeselecting={(args) => {
          if (args.target != null) navigator.clipboard.writeText(args.target.innerText);
        }}
        rowSelected={(args) => {
          if (args.target != null) navigator.clipboard.writeText(args.target.innerText);
        }}
      >
        <ColumnsDirective>{columns}</ColumnsDirective>
        <AggregatesDirective>
          <AggregateDirective>
            <AggregateColumnsDirective>
              <AggregateColumnDirective field="BookAmount" type="max" format="n0" groupFooterTemplate={(e) => <span>Max: {e.max}</span>} />
              <AggregateColumnDirective field="ReceiptAmount" type="Sum" format="n0" groupFooterTemplate={(e) => <span>Sum: {e.Sum}</span>} />
              <AggregateColumnDirective field="ShortAmount" type="Sum" format="n0" groupFooterTemplate={(e) => <span>Sum: {e.Sum}</span>} />
            </AggregateColumnsDirective>
          </AggregateDirective>
        </AggregatesDirective>
        <Inject services={[Toolbar, Edit, Page, Sort, PdfExport, ExcelExport, Filter, Group, Aggregate, Freeze, ColumnChooser, Reorder, Resize, CommandColumn]} />
      </GridComponent>
    );
  };

  return (
    <div className="content-wrapper">
      <div>
        <DialogComponent
          ref={deleteDialog}
          width={500}
          visible={showDialogOfProduct}
          close={deleteDialogClose}
          content={() => <div>DO YOU WANT TO RELEASE OR SURRENDER BL?</div>}
          isModal={true}
          header="Confirmation"
          buttons={deleteButtons}
        />
      </div>
      {callButton === true ? (
        <>
          <div className="App" id="dialog-target">
            <DialogComponent target="#dialog-target" visible={showDialogEmail} close={emailDialogClose} content={contentEmailTemplate} isModal={true} showCloseIcon={true} header={emailHeader} height={900} zIndex={8958} width={1200} />
          </div>
          <div className="App" id="dialog-target">
            <DialogComponent target="#dialog-target" visible={showDialogMessage} close={messageDialogClose} content={contentMessageTemplate} isModal={true} showCloseIcon={true} header={() => <p></p>} zIndex={8958} height={900} width={1000} />
          </div>
          <div className="App" id="dialog-targets">
            <DialogComponent target="#dialog-targets" visible={showDialoguploadPDF} content={contentuploadPDF} isModal={true} showCloseIcon={true} header={uploadPDFHeader} footerTemplate={footerTemplate} zIndex={8958} height={900} width={1000} />
          </div>
        </>
      ) : null}
      <div>
        <div>
          <p className="lists-headings">
            PI Sales Agent List
            <button onClick={(e) => { e.preventDefault(); setIsToggled(!isToggled); }} className={`toggle-templete ${isToggled ? 'active' : ''}`}>
              {ToggledValue}
            </button>
          </p>
          <TemplateCode
            isToggled={isToggled}
            ColumnProps={ColumnProps}
            dataBound={databound}
            getListService={getListService}
            getColumns={getColumnsDetail}
            InputListSecurity={InputListSecurity}
            visibleSortPassFields={visibleSortPassFields}
            visibleSortPass={visibleSortPass}
            groupingArray={groupingArray}
            defaultSortColumnName="SerialNo"
            defaultSortColumnType="Descending"
            onLoad={onLoad}
          />
          {showDialogs && (
            <HardDelete
              {...deletingProps}
              showResult={(e) => {
                setShowDialogs(false);
                if (e === false) getListService();
              }}
            />
          )}
          {piisLoading === false ? <ListGridComponent /> : <div className="loader-div"><img src={imgSrc} alt="" /></div>}
        </div>
      </div>
    </div>
  );
}
